// «Te he preparado un pedido para Santi · Revisar» (entrega 2, propuesta §5.4): cuando un agente deja preparado un pedido
// para Santi (`pelota_abrir` → `GET /agentes/:id`), su chat lo dice en UNA línea al final, nunca con una tarjeta que se envíe
// desde allí. «Revisar» abre «Pedir algo a Santi» con su título y su texto en la caja; lo que sale a Santi sale de allí,
// con Enviar. Solo para la sesión de Pau (un socio no pide cosas a Santi en su nombre).
import { Bot } from 'lucide-react';
import { useEffect } from 'react';
import { t } from '../../../i18n';
import { ENLACE } from './piezas';
import { useHablaComoPau, usePelotasStore } from './store';

export function PedidoEnElChat({ agentId }: { agentId: string }) {
  const pedido = usePelotasStore((s) => s.pedidos[agentId] ?? null);
  const cargarPedido = usePelotasStore((s) => s.cargarPedido);
  const abrirPedido = usePelotasStore((s) => s.abrirPedido);
  const comoPau = useHablaComoPau();
  useEffect(() => {
    if (comoPau) void cargarPedido(agentId);
  }, [agentId, comoPau, cargarPedido]);
  if (!comoPau || !pedido) return null;
  return (
    <p className="mt-3 flex items-center gap-2 pl-10 text-o-texto text-oficina-texto2" data-testid="pedido-en-el-chat">
      <Bot className="h-4 w-4 shrink-0 text-oficina-meta-pau" aria-hidden />
      {t('oficinaV2.pelotas.borrador.pedidoListo')} ·
      <button type="button" onClick={() => abrirPedido(agentId)} className={ENLACE} data-testid="pedido-revisar">
        {t('oficinaV2.pelotas.borrador.revisar')}
      </button>
    </p>
  );
}
